var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TypeBody',{staticClass:"max-w-7xl mx-auto pb-20 flex flex-col gap-2",attrs:{"tag":"div"},domProps:{"innerHTML":_vm._s(_vm.copy)}})}
var staticRenderFns = []

export { render, staticRenderFns }